import Vue from 'vue'
import { getPerUnitPrice } from 'lib/util'

Vue.component('product-card-price-line', {
  props: [
    'variant',
    'label',
    'subscriptionMode'
  ],
  computed: {
    onSale () {
      return this.variant.compare_at_price ? this.variant.compare_at_price > this.variant.price : false
    },
    currentPrice () {
      if (this.subscriptionMode && this.variant.subscriptions) {
        return parseFloat(this.variant.subscriptions.discount_variant_price) * 100
      }
      return this.variant.price
    },
    perUnitPrice () {
      const perunitPrice = getPerUnitPrice(this.variant)
      return perunitPrice ? `${perunitPrice} | ` : ''
    }
  },
  template: `
    <dt class="p1 product-card-price-line" v-if="variant">
      <span class="p1 align-c f jcc aic" v-if="perUnitPrice">
        <span class="product-form__unitprice mr025" v-html="perUnitPrice"></span>
        {{ label }} <span class="dark-grey p2 italic pl025"><del v-if="onSale">{{ variant.compare_at_price | formatPrice(true, 2) }}</del>  <ins>({{ currentPrice | formatPrice(true, 2) }})</ins></span>
      </span>
      <p class="product-card-price-line__bundles" v-else>
        <span class="p1 align-c f jcc aic">
          {{ label }} | <span class="p1 pl025">
            <ins>{{ currentPrice | formatPrice(true, 2) }}</ins>
          </span>
        </span>
        <span class="p3 align-c dark-grey">
          <ins v-if="onSale">({{ variant.compare_at_price | formatPrice(true, 2) }} Value)</ins>
        </span>
      </p>
    </dt>
  `
})
